import {
  GetGrowthWheelByRoleIdDto,
  GetGrowthWheelByUserIdDto,
  GrowthWheel,
  CompetencyArea,
  UpdateCompetencyEvaluationDto,
  UpdateCompetencyEvaluationPayload,
} from '../types/GrowthWheel'
import { timeoffApi } from './timeoff.api'

export interface CompetencyEvaluationResponse {
  id: number
  selfLevel: number | null
  selfNote: string | null
  leaderLevel: number | null
  leaderNote: string | null
  focus: boolean
}

const growthWheelEndpoints = timeoffApi.injectEndpoints({
  endpoints: build => ({
    getAllGrowthWheels: build.query<GrowthWheel[], void>({
      query: () => `/growth-wheel`,
      providesTags: ['GrowthWheelData'],
    }),
    getGrowthWheelByRoleId: build.query<GrowthWheel, GetGrowthWheelByRoleIdDto>({
      query: query =>
        `/growth-wheel/role/${query.roleId}`,
      providesTags: ['GrowthWheelData'],
    }),
    getGrowthWheelWithEvaluationsByUserId: build.query<
      CompetencyArea[],
      GetGrowthWheelByUserIdDto
    >({
      query: query => `/growth-wheel/user/${query.userId}/competency-evaluations`,
      providesTags: ['GrowthWheelData'],
    }),
    updateCompetencyEvaluation: build.mutation<
      CompetencyEvaluationResponse,
      UpdateCompetencyEvaluationDto
    >({
      query: ({ evaluationId, payload }) => ({
        url: `/growth-wheel/competency-evaluation/${evaluationId}`,
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: ['GrowthWheelData'],
    }),
  }),
})

export const {
  useGetAllGrowthWheelsQuery,
  useGetGrowthWheelByRoleIdQuery,
  useGetGrowthWheelWithEvaluationsByUserIdQuery,
  useUpdateCompetencyEvaluationMutation,
} = growthWheelEndpoints

export type { UpdateCompetencyEvaluationPayload }
